import React from 'react'
import i18n from 'i18next'

import Button from '../../../../UniformComponents/Button'

const QuestionFooter = (props) => {
    const {
        reportStore,
        dataKey,
    } = props

    return (
        <div
            className="questionFooter"
        >
            <Button
                cssClass="tertiary regular"
                label={i18n.t('report_export_options')}
                icon="fa-light fa-folder-arrow-down"
                onClick={() => reportStore.downloadQuestionExcel(dataKey)}
            />
        </div>
    )
}

export default QuestionFooter
